<template>
    <v-container tag="section">
        <v-row>
            <v-col class="py-sm-8 py-3">
                <h3 class="px-sm-9">{{ label }}</h3>
            </v-col>
        </v-row>
        <v-row class="flex-column flex-sm-row">
            <v-col v-for="(resource, index) in resources" :key="resource.id" cols="12" md="4" :class="index > 2 ? 'pt-md-8': 'py-md-0'" class="d-flex">
                <v-card outlined tile flat class="v-card__borders-govt--left" :href="resource.url">
                    <v-card-title class="px-4 px-md-7 py-8">
                        <h4 class="mb-0">
                            {{ resource.title }}
                            <v-card-actions class="ml-auto align-self-start">
                                <v-btn icon :title="`Opens in new tab. Show more information on ${resource.title}`">
                                    <v-icon right color=secondary>{{ resource.icon }}</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </h4>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: [
            'label'
        ],
        data() {
            return {
                resources: [],
            }
        },
        mounted() {
            this.$axios.get(this.$store.state.client_vars.RESOURCES)
                .then(response => {
                    this.resources = response.data
                })
                .catch(error => console.log('Failed to update Resources', error))
        }
    }
</script>

<style scoped lang="scss">
    .d-flex .v-card {
        flex: 1 1 auto;
    }

    .v-card__title {

        h4 {
            position: relative;
            width: 100%;
            display: flex;
            align-items: center;
        }
        
        * {
            margin-bottom: 0;
            padding: 0;
        }
    }
</style>